export default {
  getFilter: (state) => state.filter,
  relationshipType: (state) => state.relationshipType,
  casteType: (state) => state.casteType,
  identityType: (state) => state.identityType,
  village: (state) => state.village,
  block: (state) => state.block,
  tehsil: (state) => state.tehsil,
  district: (state) => state.district,
  state: (state) => state.state,
  country: (state) => state.country,
  brands: (state) => state.brands,
  gender: (state) => state.gender,
  marital: (state) => state.marital,
  selectedBrand: (state) => state.selectedBrand,
  brandFinYear: (state) => state.brandFinYear,
  GST_Type: (state) => state.GST_Type,
  firmType: (state) => state.firmType,
  purchaseType: (state) => state.purchaseType,
  productUnit: (state) => state.productUnit,
  adminEmail: (state) => state.adminEmail,
  finYear: (state) => state.finYear,
  roleAndPermission: (state) => state.roleAndPermission,
  brandPackageTypes: (state) => state.brandPackageTypes,
  stockReportTypes: (state) => state.stockReportTypes
}



// WEBPACK FOOTER //
// ./src/store/global/getters.js